const storedRegistration = JSON.parse(window.localStorage.getItem('registration'))
const initialState = storedRegistration ? storedRegistration : { step: 0, maxStep: 1, user: null, newUser: false, errors: {} }


export const registration = {
  namespaced: true,
  state: initialState,
  actions: {
    nextStep({ commit, state }) {
      if(state.step < state.maxStep) {
        commit('setStep', state.step+1)
      }
    },
    previousStep({ commit, state }) {
      if(state.step > 0) {
        commit('setStep', state.step-1)
      }
    },
    setStep ({ commit }, step) {
      commit('setStep', step)
    },
    setMaxStep({ commit, state }, step) {
      commit('setMaxStep', step)
      if(state.step > step) {
        commit('setStep', 0)
      }
    },
    setUser({ commit, state }, user) {
      if(state.user !== user) {
        commit('setUser', user)
        commit('setStep', 0)
      }
    },
    setNewUserState({ commit }, newUserState) {
      commit('setNewUserState', newUserState)
    },
    setErrors({ commit }, errors) {
      commit('setErrors', errors)
    }
  },
  mutations: {
    setStep (state, step) {
      state.step = step
      window.localStorage.setItem('registration', JSON.stringify(state))
    },
    setMaxStep (state, step) {
      state.maxStep = step
      window.localStorage.setItem('registration', JSON.stringify(state))
    },
    setUser(state, user) {
      state.user = user
      window.localStorage.setItem('registration', JSON.stringify(state))
    },
    setNewUserState(state, newUserState) {
      state.newUser = newUserState
      window.localStorage.setItem('registration', JSON.stringify(state))
    },
    setErrors(state, errors) {
      state.errors = errors
      window.localStorage.setItem('registration', JSON.stringify(state))
    }
  }
}
